var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoEsNulo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_473_6109)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 44C34.1503 44 44 34.1503 44 22C44 9.84974 34.1503 0 22 0C9.84974 0 0 9.84974 0 22C0 34.1503 9.84974 44 22 44Z",
    fill: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21 27.1591C20.1439 27.1591 19.4148 26.9261 18.8125 26.4602C18.2102 25.9905 17.75 25.3106 17.4318 24.4205C17.1136 23.5265 16.9545 22.447 16.9545 21.1818C16.9545 19.9242 17.1136 18.8504 17.4318 17.9602C17.7538 17.0663 18.2159 16.3845 18.8182 15.9148C19.4242 15.4413 20.1515 15.2045 21 15.2045C21.8485 15.2045 22.5739 15.4413 23.1761 15.9148C23.7822 16.3845 24.2443 17.0663 24.5625 17.9602C24.8845 18.8504 25.0455 19.9242 25.0455 21.1818C25.0455 22.447 24.8864 23.5265 24.5682 24.4205C24.25 25.3106 23.7898 25.9905 23.1875 26.4602C22.5852 26.9261 21.8561 27.1591 21 27.1591ZM21 25.9091C21.8485 25.9091 22.5076 25.5 22.9773 24.6818C23.447 23.8636 23.6818 22.697 23.6818 21.1818C23.6818 20.1742 23.5739 19.3163 23.358 18.608C23.1458 17.8996 22.839 17.3598 22.4375 16.9886C22.0398 16.6174 21.5606 16.4318 21 16.4318C20.1591 16.4318 19.5019 16.8466 19.0284 17.6761C18.5549 18.5019 18.3182 19.6705 18.3182 21.1818C18.3182 22.1894 18.4242 23.0455 18.6364 23.75C18.8485 24.4545 19.1534 24.9905 19.5511 25.358C19.9527 25.7254 20.4356 25.9091 21 25.9091Z",
    fill: "#666666"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 21.7614H26V22.8523H16V21.7614Z",
    fill: "#666666"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_473_6109"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoEsNulo);
export default __webpack_public_path__ + "static/media/NoEsNulo.cf2c2e23308aa018f21b16c4cb9d2def.svg";
export { ForwardRef as ReactComponent };